// TODO: dead after surveys.dataxing.com prescreener move (2026-05-08).
// Panelists are now redirected from country's redirectToSurvey straight to
// surveys.dataxing.com/#/PreScreenQues/:surveyId/:userId, which renders
// admin/frontend/src/Components/DXTest/PreScreenQuesPage.tsx (brand-neutral
// runtime page). This country component is no longer reachable.
// Keep the file until next cleanup pass.

import { makeStyles, Paper, Typography, Container } from "@material-ui/core";
import { Assets } from "enums";
import { useEffect, useState } from "react";
import { AuthAPI } from "API";
import { useLocation } from "react-router";
import Select from 'react-select';
import { branding } from '../../config/portalBranding';

// Define types for API response
interface Question {
    survey_id: string;
    id: number;
    created_at: string;
    updated_at: string;
    deleted_at?: string;
    status: string;
    question: string;
    answer: string;
}

function PreScreenQuesPage() {
    const [preScreenQueApiData, setPreScreenQueApiData] = useState<Question[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [currentPreQues, setCurrentPreQues] = useState<Question | null>(null);
    const [formData, setFormData] = useState<{ question: string; answer: [] }[]>([{ question: "", answer: [] }]);
    const [submitPreBtnTF, setSubmitPreBtnTF] = useState(false);
    const location = useLocation();

    const useStyles = makeStyles((theme) => ({
        root: { flexGrow: 1, },
        appBar: { marginBottom: theme.spacing(3), },
        content: { padding: theme.spacing(3), textAlign: 'left', },
        paper: { padding: theme.spacing(2), display: 'flex', overflow: 'auto', flexDirection: 'column', alignItems: 'center', },
        logo: { width: '100%', maxWidth: '400px', },
        grow: { flexGrow: 1, },
        btn: {
            padding: "10px 20px", color: "black", backgroundColor: "linear-gradient(#e7e7e7, #f3f3f3)", borderRadius: "10px", border: "1px solid #8f8f8f", margin: "1rem",
            '&:hover': { backgroundColor: "#008083 !important", color: "#ffffff", transform: "scale(1.05)", },
        },
        progress: {
            background: "rgba(0,0,0,.2)", borderRadius: "5px", width: "30%", height: "1rem",
            [theme.breakpoints.down('sm')]: { width: "80%", },
            [theme.breakpoints.up('sm')]: { width: "30%", },
        },
        footer: { bottom: 10, right: 10, display: 'flex', position: "fixed", padding: "10px" },
    }));

    const preScreenQuefetchList = async () => {
        const data = { survey_id: location.pathname.split("/").at(-2) };
        try {
            const responseQueData: Question[] = await AuthAPI.getSurveyQuestions(data);
            const respoPreScreenData = responseQueData.toSorted((a, b) => { return a.questionDisplayOrder - b.questionDisplayOrder });
            setPreScreenQueApiData(respoPreScreenData);
            setCurrentPreQues(respoPreScreenData[0] || null);
        } catch (err) {
            console.error("Failed to fetch survey questions:", err);
        }
    };

    const nextButton = () => {
        if (formData[currentIndex].answer.length < 1) { alert("choose answer"); return; }
        if (currentIndex < preScreenQueApiData.length - 1) {
            setFormData((prevFormData) => {
                if (currentIndex == prevFormData.length - 1 && prevFormData.length < preScreenQueApiData.length) {
                    return [...prevFormData, { "question": "", "answer": [] }];
                } else { return [...prevFormData]; }
            });
            setCurrentIndex(currentIndex + 1);
            setCurrentPreQues(preScreenQueApiData[currentIndex + 1]);
        }
    };

    const previousButton = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setCurrentPreQues(preScreenQueApiData[currentIndex - 1]);
        }
    };

    const handleSelectAnswer = (evt, answer, type) => {
        let newArr = [];
        setFormData((prevFormData) => {
            const updatedFormData = [...prevFormData];
            const previousAnswers = updatedFormData[currentIndex] ? updatedFormData[currentIndex].answer : [];
            if (type == "checkbox") {
                newArr = evt.target.checked ? [...previousAnswers, answer] : [...previousAnswers].filter(e => e != answer);
            } else {
                newArr = [...previousAnswers, answer].filter(e => e == answer && e != "");
            }
            updatedFormData[currentIndex] = { "question": currentPreQues?.id, "answer": newArr };
            return updatedFormData;
        });
    }

    const handleMultiSelectAnswers = (selectedMultisAnswers) => {
        setFormData((prevFormData) => {
            const updatedFormData = [...prevFormData];
            let newArr = selectedMultisAnswers.map(option => option.value);
            updatedFormData[currentIndex] = { "question": currentPreQues?.id, "answer": newArr };
            return updatedFormData;
        });
    }

    const handleDropDownSelectAnswers = (selectedOptionVal) => {
        setFormData((prevFormData) => {
            let newArr = selectedOptionVal.value;
            const updatedFormData = [...prevFormData];
            updatedFormData[currentIndex] = { "question": currentPreQues?.id, "answer": [newArr] };
            return updatedFormData;
        });
    }

    const handlePreScreenQueSubmit = async () => {
        if (formData[currentIndex].answer.length < 1 && preScreenQueApiData.length > 0) { alert("choose answer"); return; }
        const data = {
            survey_id: location.pathname.split('/').at(-2),
            user_id: location.pathname.split('/').at(-1),
            details: preScreenQueApiData.length > 0 ? formData : []
        };
        try {
            setSubmitPreBtnTF(true);
            const response = await AuthAPI.matchAnswers(data);
            window.history.replaceState(null, '', '');
            window.location.href = response;
        } catch (err) {
            setSubmitPreBtnTF(false);
            alert(err);
            console.error("Submission error:", err);
        }
    };



    const classes = useStyles();

    useEffect(() => { preScreenQuefetchList(); }, []);

    return (
        <div className={classes.root}>
            <Container maxWidth="lg" className={classes.content}>
                <Paper className={classes.paper}>
                    <img alt="Logo" src={branding.logo || Assets.Logo2} className={classes.logo} />
                </Paper>
                {preScreenQueApiData.length > 0 ? <div className="mt-1">
                    <div
                        className=" w-100"
                        style={{ textAlign: "center", marginTop: "2rem" }}
                    >
                        <div>{`${currentIndex + 1}/${preScreenQueApiData.length}`}</div>
                        <Typography
                            variant="h4"
                            className="mt-5"
                        >
                            {currentPreQues ? "" : "Loading question..."}
                        </Typography>
                    </div>
                    <div className="" style={{ display: "grid", placeItems: "center" }}>
                        <div>
                            {currentPreQues?.question && (
                                <div className="">
                                    <div className="">
                                        <h5>{currentPreQues ? currentPreQues.question : ""}</h5>
                                        {currentPreQues.questionType === "Radio" && currentPreQues?.answer?.map((elem, index) => (
                                            <div className="custom-control custom-radio" key={"radio" + index}>
                                                <input
                                                    type="radio"
                                                    id={`prescreen-${currentIndex}-${index}`}
                                                    name={`prescreen-${currentIndex}`}  // same name for group
                                                    checked={formData[currentIndex]?.answer?.includes(elem) || false}
                                                    className="custom-control-input"
                                                    onChange={(evt) => handleSelectAnswer(evt, elem, "radio")}
                                                />
                                                <label className="custom-control-label" htmlFor={`prescreen-${currentIndex}-${index}`}>
                                                    <span className="text-lg">{elem}</span>
                                                </label>
                                            </div>
                                        ))}

                                        {(currentPreQues.questionType === "Checkbox" || currentPreQues.questionType === "checkbox") &&
                                            currentPreQues?.answer?.map((elem, index) => (
                                                <div className="col ml-2" key={"currentPreQuesAns" + index}>
                                                    <input
                                                        type="checkbox"
                                                        id={`prescreen-${index}`}
                                                        name={`prescreen-${index}`}
                                                        checked={formData[currentIndex]?.answer.includes(elem) || false}
                                                        className="custom-control-input"
                                                        onChange={(evt) => handleSelectAnswer(evt, elem, "checkbox")}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className='text-lg'>{elem}</span></label>
                                                </div>
                                            ))
                                        }
                                        {(currentPreQues?.questionType == "Range") && (
                                            <div>
                                                <select
                                                    name="rangeSelect"
                                                    id="rangeSelect"
                                                    className="form-control"
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer[0] : ""}
                                                    onChange={(evt) => handleSelectAnswer(evt, evt.target.value, "Range")}
                                                >
                                                    <option value="">Select option</option>
                                                    {(() => {
                                                        let result = [];
                                                        currentPreQues?.answer?.forEach(range => {
                                                            const from = parseInt(range.answer.fromValue, 10);
                                                            const to = parseInt(range.answer.toValue, 10);
                                                            for (let i = from; i <= to; i++) { result.push(i); };
                                                        });
                                                        let finalResult = Array.from(new Set(result)).sort((a, b) => { return (a - b) });
                                                        return finalResult.map((value) => (
                                                            <option value={value} key={value + "123"}> {value} </option>
                                                        ));
                                                    })()}
                                                </select>
                                            </div>
                                        )}
                                        {(currentPreQues?.questionType == "MultiSelectDropdown") && (
                                            <div>
                                                <Select
                                                    name='MultiSelectDropdown'
                                                    id='MultiSelectDropdown'
                                                    onChange={(evt) => handleMultiSelectAnswers(evt)}
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer?.map((ele) => { return { label: ele, value: ele } }) : ""}
                                                    isMulti
                                                    options={currentPreQues?.answer?.map((ele) => { return { label: ele, value: ele } })}
                                                />
                                            </div>
                                        )}
                                        {(currentPreQues?.questionType == "Dropdown") &&
                                            <div>
                                                <Select
                                                    name='Dropdown'
                                                    id='Dropdown'
                                                    onChange={(evt) => handleDropDownSelectAnswers(evt)}
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer?.map((ele) => { return { label: ele, value: ele } }) : ""}
                                                    options={currentPreQues?.answer?.map((ele) => { return { label: ele, value: ele } })}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-5" style={{ display: "grid", placeItems: "center", width: "100%" }}>
                        <div className={classes.progress}>
                            <div style={{ background: "#008083", borderRadius: "5px", width: `${(currentIndex + 1) / preScreenQueApiData.length * 100 + "%"}`, height: "1rem" }}></div>
                            <div style={{ textAlign: "end" }}>{Math.ceil((currentIndex + 1) / (preScreenQueApiData.length) * 100) + "%"}</div>
                        </div>
                    </div>
                </div> :
                    <div className="mt-5 text-center">
                        <h1>Click "Proceed" to continue survey.</h1>
                    </div>
                }
                <div>
                    <div className={classes.footer}>
                        <button
                            type="button"
                            onClick={previousButton}
                            className="btn btn-primary mr-3"
                            disabled={currentIndex === 0}
                        >
                            Previous
                        </button>
                        <button
                            type="button"
                            onClick={currentIndex < preScreenQueApiData.length - 1 ? nextButton : handlePreScreenQueSubmit}
                            className="btn btn-primary mr-3"
                            disabled={submitPreBtnTF}
                        >
                            {currentIndex < preScreenQueApiData.length - 1 ? "Next" : "Proceed"}
                        </button>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default PreScreenQuesPage;